var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokensIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 10.7917V13.875C15.4166 16.475 12.9916 18.5834 9.99992 18.5834C7.00825 18.5834 4.58325 16.475 4.58325 13.875V10.7917C4.58325 13.3917 7.00825 15.25 9.99992 15.25C12.9916 15.25 15.4166 13.3917 15.4166 10.7917Z",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 6.62502C15.4166 7.38336 15.2082 8.08335 14.8416 8.68335C13.9499 10.15 12.1166 11.0834 9.99992 11.0834C7.88325 11.0834 6.04992 10.15 5.15825 8.68335C4.79159 8.08335 4.58325 7.38336 4.58325 6.62502C4.58325 5.32502 5.19158 4.15002 6.16658 3.30002C7.14991 2.44169 8.49992 1.91669 9.99992 1.91669C11.4999 1.91669 12.8499 2.44169 13.8333 3.29169C14.8083 4.15002 15.4166 5.32502 15.4166 6.62502Z",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 6.62502V10.7917C15.4166 13.3917 12.9916 15.25 9.99992 15.25C7.00825 15.25 4.58325 13.3917 4.58325 10.7917V6.62502C4.58325 4.02502 7.00825 1.91669 9.99992 1.91669C11.4999 1.91669 12.8499 2.44169 13.8333 3.29169C14.8083 4.15002 15.4166 5.32502 15.4166 6.62502Z",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokensIconActive);
export default __webpack_public_path__ + "static/media/tokens-icon-active.4a4a2bd9b51330b3e89eea3b977a3099.svg";
export { ForwardRef as ReactComponent };